import { Box, Text, TextButton } from '@wix/design-system';
import { SwitchProductModule } from '@wix/package-picker-sdk';
import React from 'react';
import { useCurrentModule } from '../ModuleProvider';
export const SwitchPlanHeaderBanner = () => {
  var _currentProduct$prici;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const {
    data: currentProductData,
    isLoading: isCurrentProductLoading
  } = module.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const {
    currentProduct,
    isCurrentProductInOffering
  } = currentProductData ?? {};
  const monthlyPrice = currentProduct == null || (_currentProduct$prici = currentProduct.pricing) == null || (_currentProduct$prici = _currentProduct$prici.monthlyTotal) == null ? void 0 : _currentProduct$prici.formattedAmount;
  if (isCurrentProductLoading || !currentProduct) {
    return null;
  }
  if (isCurrentProductInOffering) {
    return null;
  }
  const handleViewCurrentPlanModal = () => {
    SwitchProductModule.SDK.modalsController.PlanFeaturesModal.show({
      onClose: () => {
        module.internals.bi.onPlanFeaturesModalClose == null || module.internals.bi.onPlanFeaturesModalClose({});
      },
      onShow: () => {
        module.internals.bi.onPlanFeaturesModalShow == null || module.internals.bi.onPlanFeaturesModalShow({});
      }
    });
  };
  const bannerKey = monthlyPrice ? 'premium-purchase-plan.change-plan-sunrise.banner' : 'premium-purchase-plan.change-plan.banner';
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    width: "100%",
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Text, null, t(bannerKey, {
    planName: currentProduct == null ? void 0 : currentProduct.productName,
    originalPlanPrice: monthlyPrice
  })), /*#__PURE__*/React.createElement(TextButton, {
    onClick: handleViewCurrentPlanModal
  }, t('change_plan.header.view_current_plan_advanced')));
};
//# sourceMappingURL=SwitchPlanHeaderBanner.js.map